<template>
  <v-card v-if="owner" tile>
    <v-toolbar color="grey lighten-4" light tile flat>
      <v-toolbar-title centered class="headline font-weight-bold">
        Owner details
      </v-toolbar-title>
      <div class="flex-grow-1"></div>
      <v-switch
        label="Activate"
        v-if="company.has_owner_consent"
        inset
        :loading="isActivating"
        :input-value="!!owner.is_active"
        @change="toggleActivity"
        :disabled="isActivating"
        color="primary"
        ripple
      />
    </v-toolbar>

    <v-card-text>
      <v-row>
        <v-col cols="5">
          <key-value title="Id" :value="owner.id" type="none" />
          <key-value title="First Name" :value="owner.first_name" />
          <key-value title="Last Name" :value="owner.last_name" />

          <key-value title="Phone Number" :value="owner.full_phone_number" />
        </v-col>
        <v-col cols="4">
          <key-value title="Verification Status">
            <h3 class="success--text headline">
              {{ owner.verified_at ? "VERIFIED" : "PENDING" }}
            </h3>
          </key-value>
        </v-col>
        <v-col cols="3">
          <div class="d-flex flex-column align-center">
            <div class="mt-2">
              <v-btn
                rounded
                outlined
                color="primary"
                :to="{ name: 'users.show', params: { id: owner.id } }"
              >
                Profile
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: ["company"],
  data: () => ({ isActivating: false }),
  computed: {
    owner() {
      return this.company.owner;
    },
    avatar() {
      const { first_name, last_name } = this.owner;
      return String(`${first_name[0]}${last_name[0]}`).trim();
    },
  },

  methods: {
    toggleActivity() {
      this.isActivating = true;
      const { id } = this.owner;
      this.$http
        .put(`api/v1/users/${id}/activity`)
        .then((user) => {
          // we  need to update the company owner user object
          this.$emit("update:company", {
            ...this.company,
            owner: { ...this.company.owner, user },
          });
          Notify.success("Operation was successful");
        })
        .catch(this.showResponseError)
        .finally(() => (this.isActivating = false));
    },
  },
};
</script>
